import FormSelect from "./FormSelect.vue";

export default {
  extends: FormSelect
};
